
import {combineReducers} from 'redux'

import sceneItems from "./scene-items"
import microphone from "./microphone"
import search from "./search"
import globalState from "./global-state"
import camera from "./camera"
import tutorial from "./tutorial"
import hud from "./hud"
import keyboard from "./keyboard"

const reducers = combineReducers({
    sceneItems: sceneItems,
    microphone: microphone,
    search: search,
    globalState: globalState,
    camera: camera,
    tutorial: tutorial,
    hud: hud,
    keyboard: keyboard,
});

export default reducers



// WEBPACK FOOTER //
// ./src/reducers/index.js